// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2ZurI","buttons":"SendReceipts_buttons__d3qQt","email":"SendReceipts_email__8I30e","bookApptTitle":"SendReceipts_bookApptTitle__2Q1QT"};